import React from 'react';
import { Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { theme } from '../../../theme';
import { formatCurrency } from '../../../utils/formatNumbers';
import CampaignProgressBar from './CampaignProgressBar';

function ItemReplacementsBox({ replacementsSummary }) {
    const navigate = useNavigate();
    const reviewedCount = replacementsSummary.replacements_total_count - replacementsSummary.replacements_open_count;

    return (
        <Stack spacing={1.5} p={2} sx={{ backgroundColor: theme.palette.background.white, boxShadow: 5 }} onClick={() => navigate(`/physician/${replacementsSummary.physician_id}/replacements`)}>
            <Typography variant='heavy' sx={{ fontSize: '18px' }}>Item Replacements</Typography>
            <Typography variant='normal' fontSize='12px' sx={{ color: theme.palette.subtext.main }}>
                {`${replacementsSummary.replacements_total_count} replacement${replacementsSummary.replacements_total_count === 1 ? '' : 's'} across ${replacementsSummary.cards_total_count} card${replacementsSummary.cards_total_count === 1 ? '' : 's'} at ${replacementsSummary.hospitals_total_count} hospital${replacementsSummary.hospitals_total_count === 1 ? '' : 's'}.`}
            </Typography>
            {replacementsSummary.total_savings > 0 && (
                <Typography variant='normal' sx={{ fontSize: '14px', color: theme.palette.blue.main }}>
                    {`${formatCurrency(replacementsSummary.total_savings, 0)} estimated annual savings`}
                </Typography>
            )}
            <CampaignProgressBar
                isReviewed={true}
                num_steps={replacementsSummary.replacements_total_count}
                current_step={reviewedCount}
            />
        </Stack>
    );
}

export default ItemReplacementsBox;